import { Flex, Modal, Typography } from 'antd'
import React from 'react'
import { FeatureResetPassword } from '../ResetPassword'

type Props = {
  isOpenResetPassword: boolean
  setOpenResetPassword: (isOpen: boolean) => void
}

export const ResetPasswordModal: React.FC<Props> = ({
  isOpenResetPassword,
  setOpenResetPassword,
}) => {
  return (
    <>
      {isOpenResetPassword && (
        <Modal
          open={true}
          footer={<></>}
          closeIcon={<></>}
          onCancel={() => setOpenResetPassword(false)}
        >
          <Flex align="center" justify="center" vertical className="w-full">
            <Typography.Title level={3}>Reset password</Typography.Title>

            <FeatureResetPassword />
          </Flex>
        </Modal>
      )}
    </>
  )
}
